import { PrimeReactPTOptions } from "primereact/api";
import { MultiSelectPassThroughMethodOptions } from "primereact/multiselect";
import { classNames } from "primereact/utils";

import { focusHoverField } from "./common";

export const multiselect: PrimeReactPTOptions["multiselect"] = {
  root: ({ props }: MultiSelectPassThroughMethodOptions) => ({
    className: classNames(
      "inline-flex cursor-pointer select-none",
      "h-[40px]",
      "bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-md",
      props.className,
      focusHoverField,
      {
        "bg-urbe-grayLight select-none pointer-events-none cursor-default": props.disabled,
      },
    ),
  }),
  labelContainer: () => "flex items-center overflow-hidden cursor-pointer",
  label: ({ props }: MultiSelectPassThroughMethodOptions) => ({
    className: classNames(
      "block overflow-hidden whitespace-nowrap not-italic cursor-pointer overflow-ellipsis text-sm",
      "text-gray-800 dark:text-white/80",
      "p-2 transition duration-200 ",
      {
        "!p-3": props.display !== "chip" && (props.value == null || props.value == undefined),
        "!py-1.5 px-3": props.display === "chip" && props.value !== null,
      },
    ),
  }),
  token: {
    className: classNames(
      "py-1 px-2 mr-2 text-xs bg-[#E8DEF6] text-[#6E4299] rounded-full",
      "cursor-default inline-flex items-center",
    ),
  },
  removeTokenIcon: ["ml-2"],
  trigger: {
    className: classNames(
      "flex items-center justify-center shrink-0",
      "bg-transparent text-urbe-border dark:text-white/70 w-12 rounded-tr-lg rounded-br-lg",
    ),
  },
  panel: {
    className: classNames(
      "bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 border-0 rounded-md shadow-lg",
    ),
  },
  header: {
    className: classNames("p-2 text-gray-700 rounded-t-lg", "flex items-center justify-between"),
  },
  headerCheckboxContainer: {
    className: classNames(
      "inline-flex cursor-pointer select-none align-bottom relative",
      "mr-2 ml-1",
      "w-6",
    ),
  },
  closeButton: {
    className: classNames(
      "flex items-center justify-center overflow-hidden relative",
      "w-8 h-8 text-gray-500 dark:text-white/70 border-0 bg-transparent rounded-full transition duration-200 ease-in-out mr-2 last:mr-0",
      "hover:text-gray-700 dark:hover:text-white/80 hover:border-transparent hover:bg-gray-200 dark:hover:bg-gray-800/80 ",
      "focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]",
    ),
  },
  closeIcon: ["w-4 h-4 inline-block"],
  wrapper: {
    className: classNames(
      "max-h-[200px] overflow-auto",
      "bg-white text-gray-700 border-0 rounded-md shadow-lg",
      "dark:bg-gray-900 dark:text-white/80",
    ),
  },
  list: ["py-2 list-none m-0"],
  item: ({ context, state }: MultiSelectPassThroughMethodOptions) => ({
    className: classNames(
      "cursor-pointer text-xs font-normal overflow-hidden relative whitespace-nowrap text-sm",
      "m-0 px-3 py-2 border-0 transition-shadow duration-200 rounded-none",
      {
        "text-gray-700 hover:text-gray-700 hover:bg-gray-200 dark:text-white/80 dark:hover:bg-gray-800":
          !context.selected,
        "bg-rdc-primaryLight text-rdc-primary dark:bg-blue-400 dark:text-white/80":
          state.focused && context.selected,
        "bg-rdc-primaryLight text-rdc-primary dark:bg-blue-300 dark:text-white/80":
          !state.focused && context.selected,
      },
    ),
  }),
  checkboxContainer: {
    className: classNames(
      "inline-flex cursor-pointer select-none align-bottom relative",
      "mr-2",
      "w-5 h-5",
    ),
  },
  itemGroup: {
    className: classNames(
      "m-0 p-3 text-gray-800 bg-white font-bold",
      "dark:bg-gray-900 dark:text-white/80",
      "cursor-auto",
    ),
  },
  filterContainer: () => "relative",
  filterInput: {
    root: {
      className: classNames(
        "pr-7 ",
        "w-full h-[35px]",
        "font-sans text-base text-gray-700 bg-white py-1 px-3 border border-gray-300 transition duration-200 rounded-lg appearance-none",
        "dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80",
        "hover:border-gray-300 focus:outline-none focus:outline-offset-0 focus:border-gray-300 focus-visible:border-gray-300 dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]",
      ),
      placeholder: "Buscar",
      autoFocus: true,
    },
  },
  filterIcon: () => "absolute top-1/2 right-2 stroke-gray-300",
  clearIcon: () => "text-gray-500 right-12 -mt-2 absolute top-1/2",
};
